import { useGetOrganisationUsers } from '@dhl/mdp-api'
import { convertToUser } from '~/modules/users/model'

export const useOrganisationUsers = (organisationId: string) => {
  const {
    data: organisationUsers = [],
    isFetching,
    refetch,
  } = useGetOrganisationUsers(organisationId, {
    query: {
      select: (data) => data.map(convertToUser),
    },
  })

  return { organisationUsers, isFetching, refetch }
}
